import { Injectable } from '@angular/core';
import { DefaultActivity } from '../interface/activity';
import { AuthUser, UserDetail } from '../interface/auth.user';
import { AngularFirestore, Query } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { WellBeingActivity } from '@app/interface/wellBeingActivity';
import { from, Observable, of } from 'rxjs';
import * as firebase from 'firebase';
import { switchMap } from 'rxjs/operators';
import { FirebaseAuthService, StudiesService } from '@app/services';

@Injectable({
  providedIn: 'root',
})
export class WellBeingService {
  authUserId: string;
  constructor(
    private store: AngularFirestore,
    private afAuth: AngularFireAuth,
    private authService: FirebaseAuthService,
    private studiesService: StudiesService
  ) {
    this.getAuthUser(() => {});
  }

  public getAuthUser(cb: any): void {
    this.afAuth.authState.subscribe(
      (authUser: AuthUser) => {
        if (authUser) {
          this.authUserId = authUser.uid;
          cb();
        }
      },
      () => {
        this.authUserId = null;
      }
    );
  }

  public getDefaultActivityUUID(defaultActivityUUID: any) {
    localStorage.removeItem('defaultActivityUUID');
    localStorage.setItem('defaultActivityUUID', defaultActivityUUID);
  }

  public addWellBeingActivity(wellBeingActivity: any, studyDetail: any): Observable<any> {
    return this.authService.getUser().pipe(
      switchMap((user: UserDetail) => {
        if (user) {
          wellBeingActivity.createdBy = user.role;
          wellBeingActivity.createdByuserId = user.uuid;
          wellBeingActivity.studyName = studyDetail.studyName;
          wellBeingActivity.studyRef = studyDetail.docRef;
          wellBeingActivity.studyId = studyDetail.uuid;
          wellBeingActivity.createdAt = firebase.default.firestore.Timestamp.now();
          wellBeingActivity.isDelete = false;
          return this.store
            .collection<WellBeingActivity>('organisation-wellbeing-activities')
            .doc(wellBeingActivity.uuid)
            .set(wellBeingActivity);
        }
      })
    );
  }

  public updateWellBeingActivity(wellBeingActivity: any) {
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        wellBeingActivity.updatedAt = firebase.default.firestore.Timestamp.now();
        wellBeingActivity.updatedByUserId = user.uid;
        this.store
          .collection<WellBeingActivity>('organisation-wellbeing-activities')
          .doc(wellBeingActivity['uuid'])
          .update(wellBeingActivity);
        return from(wellBeingActivity.uuid);
      })
    );
  }

  public getWellBeingActivities(id: string) {
    return this.store
      .collection<any>('organisation-wellbeing-activities')
      .doc(id)
      .collection('activities')
      .valueChanges();
  }

  public getWellBeingOrgActivities(studyName: string) {
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        if (user) {
          return this.store
            .collection<WellBeingActivity>('organisation-wellbeing-activities', (ref) => {
              let query: Query = ref;
              return query.where('studyName', '==', studyName).orderBy('createdAt', 'desc');
            })
            .valueChanges();
        } else {
          return [];
        }
      })
    );
  }

  public getOneDefaultActivity() {
    return this.store
      .collection<DefaultActivity>('default-activities')
      .doc(localStorage.getItem('defaultActivityUUID'))
      .valueChanges();
  }

  public deleteWellBeingActivity(uuid: string) {
    return this.store.collection<WellBeingActivity>('organisation-wellbeing-activities').doc(uuid).delete();
  }

  public SetUserData(user: any) {
    return this.store.collection('user').doc(user.uid).set({
      email: user.email,
    });
  }

  public getWellBeingByStudyId() {
    let studyId = this.studiesService.getStudyId();
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        if (user && studyId) {
          return this.store
            .collection<WellBeingActivity>('organisation-wellbeing-activities', (ref) => {
              let query: Query = ref;
              return query.where('studyId', '==', studyId).where('isDelete', '==', false).orderBy('createdAt', 'desc');
            })
            .valueChanges();
        } else {
          return of([]);
        }
      })
    );
  }
}
